import {usePageMeta, useNoIndexMeta} from "../components/usePageMeta";
import logo from "../assets/logo-horizontal.png";
import logoWhite from "../assets/logo-horizontal-white.png";
import {common} from "../i18n";

// All that anyone but an administrator sees while the site is down for maintenance (SiteLayout), in place of the whole
// layout. Administrators sign in at /login, which still works.
export function MaintenancePage() {
    usePageMeta({ title: common.maintenance.title });
    useNoIndexMeta();
    return (
        <main id="main-content" className="container min-vh-100 d-flex flex-column justify-content-center py-5">
            <div className="home-logo mb-4" style={{ maxWidth: '32rem' }}>
                <img src={logo} alt="" width="1084" height="332" className="home-logo-light"/>
                <img src={logoWhite} alt="" width="1084" height="332" className="home-logo-dark"/>
            </div>
            <h1 className="h4 fw-normal">{common.maintenance.text}</h1>
        </main>
    );
}
